var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgStarsCircle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 32,
  fill: "var(--color-primary-info)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.63 18.505c.729-2.006 3.566-2.006 4.296 0l.7 1.925 1.924.7c2.007.729 2.007 3.566 0 4.296l-1.924.7-.7 1.924c-.73 2.007-3.567 2.007-4.297 0l-.7-1.924-1.924-.7c-2.006-.73-2.006-3.567 0-4.297l1.925-.7.7-1.924Zm19.921 3.243c-.73-2.006-3.567-2.006-4.296 0l-1.719 4.726-4.725 1.718c-2.006.73-2.006 3.567 0 4.296l4.725 1.719 1.719 4.725c.73 2.007 3.567 2.007 4.296 0l1.719-4.725 4.725-1.719c2.007-.73 2.007-3.566 0-4.296l-4.725-1.718-1.719-4.726ZM27.885 34.03c-.73-2.006-3.567-2.006-4.296 0l-1.223 3.362-3.361 1.222c-2.006.73-2.006 3.567 0 4.296l3.361 1.223 1.223 3.361c.73 2.007 3.567 2.007 4.296 0l1.223-3.361 3.361-1.223c2.006-.73 2.006-3.567 0-4.296l-3.361-1.222-1.223-3.362Z",
  fill: "#fff"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgStarsCircle);
export default ForwardRef;